import type { FredrickLocalSearchHistoryEntryV1 } from 'fredrick-local-repository';
import { calculatePriceHistoryGeometry } from '../../lib/priceHistory';
import { formatPrice } from '../../lib/marketFormat';

export function PriceHistoryChart({ entries }: { readonly entries: readonly FredrickLocalSearchHistoryEntryV1[] }) {
  const geometry = calculatePriceHistoryGeometry(entries);
  if (geometry.points.length === 0) {
    return <div className="chart-empty">No priced searches match these filters.</div>;
  }
  return <div className="price-chart-wrap">
    <svg className="price-chart" viewBox={`0 0 ${geometry.width} ${geometry.height}`} role="img">
      <title>Discrete Owl search price history</title>
      <desc>Median points with interquartile intervals and minimum-to-maximum whiskers. Searches are not connected.</desc>
      <line className="chart-axis" x1={geometry.plotLeft} y1={geometry.plotBottom} x2={geometry.plotRight} y2={geometry.plotBottom}/>
      <line className="chart-axis" x1={geometry.plotLeft} y1={geometry.plotTop} x2={geometry.plotLeft} y2={geometry.plotBottom}/>
      <text className="chart-label" x={geometry.plotLeft - 8} y={geometry.plotTop + 4} textAnchor="end">{formatPrice(geometry.valueMax)}</text>
      <text className="chart-label" x={geometry.plotLeft - 8} y={geometry.plotBottom} textAnchor="end">{formatPrice(geometry.valueMin)}</text>
      {geometry.points.map((point) => <g key={point.searchId}>
        <line className="chart-whisker" x1={point.x} x2={point.x} y1={point.yMin} y2={point.yMax}/>
        <line className="chart-iqr" x1={point.x} x2={point.x} y1={point.yP25} y2={point.yP75}/>
        <circle className="chart-point" cx={point.x} cy={point.yMedian} r="4"/>
      </g>)}
    </svg>
  </div>;
}
